import React, { useState, useEffect } from 'react';
import { useLanguage } from "../../locales/LanguageProvider";

const CookieConsent = () => {
  const { Localizer } = useLanguage();
  const t = (key) => Localizer(key, 'common');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      backgroundColor: '#212529',
      color: '#fff',
      padding: '15px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      flexWrap: 'wrap',
      gap: '10px',
      textAlign: 'center'
    }}>
      <p style={{ margin: 0, fontSize: '14px' }}>
        {t('CookieMessage')}
      </p>
      <button
        onClick={handleAccept}
        style={{
          backgroundColor: '#CC2121',
          color: '#fff',
          border: 'none',
          padding: '8px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 'bold',
          marginLeft: '15px'
        }}
      >
        {t('CookieButton')}
      </button>
    </div>
  );
};

export default CookieConsent;

